import parse, { Element } from 'html-react-parser'
import React from 'react'

import * as styles from './NewsTableOfContents.module.scss'

type Props = {
	data: string
}

type HeadingType = {
	id: string
	index: number
	element: string
	subheadings: HeadingType[]
}

const NewsTableOfContents: React.FC<Props> = ({ data }) => {
	const slugify = (text: string) => {
		return (
			'toc-' +
			text
				.toLowerCase()
				.replace(/[^\w\s-]/g, '')
				.replace(/\s+/g, '-')
		)
	}

	const createTableOfContents = (html: string) => {
		const headings: Array<Element> = []
		const headingsTree: HeadingType[] = []

		let lasth2index = 0

		parse(html, {
			replace(domNode, index) {
				if (domNode instanceof Element && domNode.attribs) {
					if (domNode.type === 'tag' && (domNode.name === 'h2' || domNode.name === 'h3')) {
						const lasth2 = headingsTree.findIndex((item) => item.index === lasth2index)

						if (domNode.name == 'h3') {
							let subheadingContent: string = ''

							if (domNode.children.length) {
								domNode.children.forEach((childEl) => {
									if (childEl.type === 'text') {
										subheadingContent = childEl.data
									}

									if (childEl.type === 'tag') {
										// @ts-ignore
										subheadingContent = childEl.children[0].data
									}
								})
							}

							headingsTree[lasth2].subheadings.push({
								index,
								id: slugify(subheadingContent),
								element: subheadingContent,
								subheadings: [],
							})
						}

						if (domNode.name == 'h2') {
							let headingContent: string = ''

							if (domNode.children.length) {
								domNode.children.forEach((childEl) => {
									if (childEl.type === 'text') {
										headingContent = childEl.data
									}

									if (childEl.type === 'tag') {
										// @ts-ignore
										headingContent = childEl.children[0].data
									}
								})
							}

							headings.push(domNode)
							headingsTree.push({
								index,
								id: slugify(headingContent),
								element: headingContent,
								subheadings: [],
							})
						}

						if (domNode.name === 'h2') {
							lasth2index = index
						}
					}
				}
			},
		})

		// Filter out undefined values
		return headingsTree.filter((item) => item)
	}

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()

		const target = e.target as HTMLAnchorElement
		const id = target.getAttribute('href')

		if (!id) return

		const element = document.querySelector(id)

		if (element) {
			element.scrollIntoView({ behavior: 'smooth' })
		}
	}

	const tableOfContents = createTableOfContents(data)

	return (
		<div className={styles.tableOfContents}>
			<ul className={styles.links}>
				{tableOfContents.map((heading) => {
					return (
						<li key={heading.id}>
							<a href={`#${heading.id}`} onClick={(e) => handleClick(e)} className={styles.link}>
								{heading.element}
							</a>

							{heading.subheadings.length > 0 && (
								<ul className={styles.subLinks}>
									{heading.subheadings.map((subheading) => {
										return (
											<li key={subheading.id}>
												<a
													href={`#${subheading.id}`}
													onClick={(e) => handleClick(e)}
													className={styles.link}
												>
													{subheading.element}
												</a>
											</li>
										)
									})}
								</ul>
							)}
						</li>
					)
				})}
			</ul>
		</div>
	)
}

export default NewsTableOfContents
